import type { PublicPerson } from '../types.ts';

export const HIDDEN_LABEL = 'Someone without a phone';

export type ClaimantRow = { id: string; label: string; locked: boolean };

/**
 * Rows for a friend's "Who shared the X?" sheet, not counting "You".
 * Pickable people are everyone else who joined with a phone. Spots the payer added for
 * someone without a phone can't be picked, but if they're already on the item they still
 * get a locked row with the anonymous label, so the row count matches "Split N ways".
 */
export function claimantRows(people: PublicPerson[], meId: string, claimedIds: string[]): ClaimantRow[] {
  const on = new Set(claimedIds);
  const rows: ClaimantRow[] = [];
  for (const p of people) {
    if (p.id === meId) continue;
    if (p.addedByPayer) {
      if (on.has(p.id)) rows.push({ id: p.id, label: HIDDEN_LABEL, locked: true });
    } else {
      rows.push({ id: p.id, label: p.isPayer ? `${p.name} (covered the bill)` : p.name, locked: false });
    }
  }
  return rows;
}
